<ng-container *ngFor="let uData of userListDatas">
    <app-connect-socket-data-indikator [uData]="uData">
    </app-connect-socket-data-indikator>
</ng-container>

<ng-container *ngIf="userListDatas.length == 0"><i class=" ri-wifi-off-fill"></i></ng-container>